const e = {
  undo: "Annuler",
  redo: "Refaire",
  confirm: "Confirmer",
  clear: "Clair",
  more: "plus",
  cancel: "Annuler",
  update: "Mise à jour"
}, r = {
  positiveText: "Confirmer",
  negativeText: "Annuler"
}, t = {
  placeholder: "Veuillez sélectionner",
  loading: "Chargement"
}, n = {
  clear: "Clair",
  now: "Maintenant",
  confirm: "Confirmer",
  selectTime: "Sélectionnez une heure",
  selectDate: "Sélectionnez une date",
  datePlaceholder: "Sélectionnez une date",
  datetimePlaceholder: "Sélectionnez la date et l'heure",
  monthPlaceholder: "Sélectionnez le mois",
  yearPlaceholder: "Sélectionnez l'année",
  quarterPlaceholder: "Sélectionner un trimestre",
  startDatePlaceholder: "Date de début",
  endDatePlaceholder: "Date de fin",
  startDatetimePlaceholder: "Date et heure de début",
  endDatetimePlaceholder: "Date et heure de fin",
  startMonthPlaceholder: "Mois de début",
  endMonthPlaceholder: "Mois de clôture",
  today: "Aujourd'hui"
}, a = {
  checkTableAll: "Sélectionnez tout dans le tableau",
  uncheckTableAll: "Désélectionnez tout dans le tableau",
  confirm: "Confirmer",
  clear: "Clair",
  apply: "Appliquer",
  filters: "Filtres",
  sort: "Trier"
}, o = {
  sourceTitle: "Source",
  targetTitle: "Cible"
}, l = {
  selectAll: "Sélectionner tout",
  unselectAll: "Désélectionner tout",
  clearAll: "Clair"
}, i = {
  description: "Pas de données"
}, c = {
  placeholder: "Veuillez sélectionner"
}, s = {
  placeholder: "Sélectionnez une heure",
  positiveText: "OK",
  negativeText: "Annuler",
  now: "Maintenant"
}, d = {
  goto: "Goto",
  selectionSuffix: "page",
  next: "Suivant",
  previous: "Précédent"
}, u = {
  add: "Ajouter"
}, p = {
  loading: "Chargement"
}, m = {
  placeholder: "Veuillez saisir"
}, g = {
  placeholder: "Veuillez saisir"
}, f = {
  create: "Créer"
}, h = {
  title: "Éditeur de thème",
  clearAllVars: "Effacer toutes les variables",
  clearSearch: "Effacer la recherche",
  filterCompName: "Nom du composant du filtre",
  filterVarName: "Nom de la variable de filtre",
  import: "Importer",
  export: "Exporter",
  restore: "Réinitialiser par défaut"
}, C = {
  tipPrevious: "Image précédente (←)",
  tipNext: "Image suivante (→)",
  tipCounterclockwise: "Dans le sens inverse des aiguilles d'une montre",
  tipClockwise: "Dans le sens des aiguilles d’une montre",
  tipZoomOut: "Zoom arrière",
  tipZoomIn: "Zoom",
  tipClose: "Fermer (Esc)",
  tipOriginalSize: "Zoom à la taille d'origine"
}, P = {
  heading: "Trier et filtrer",
  sortHeading: "Trier par",
  newestFirst: "Le plus récent en premier",
  oldestFirst: "Le plus ancien en premier",
  ascending: "Asc",
  descending: "Description",
  apply: "Appliquer",
  clear: "Clair",
  cancel: "Annuler",
  filters: "Filtres"
}, T = {
  noMatchingFound: "Aucun résultat correspondant trouvé"
}, D = {
  margin: "Marge",
  padding: "Remplissage",
  reset: "Réinitialiser",
  errorMsg: "La valeur délivrée est invalide."
}, S = {
  brandColors: "Couleurs de la marque",
  noBrandColors: "Vous n'avez pas encore ajouté de couleurs de marque.",
  getStarted: "Commencer",
  add: "Ajouter",
  default: "Par défaut"
}, A = {
  addColor: "Ajouter une nouvelle couleur",
  editColor: "Modifier la couleur",
  add: "Ajouter",
  noData: "Vous n'avez pas encore ajouté de couleurs.",
  invalidCode: "Code de couleur non valide",
  defaultColor: "Couleurs par défaut"
}, v = {
  global: e,
  Popconfirm: r,
  Cascader: t,
  DatePicker: n,
  DataTable: a,
  LegacyTransfer: o,
  Transfer: l,
  Empty: i,
  Select: c,
  TimePicker: s,
  Pagination: d,
  DynamicTags: u,
  Log: p,
  Input: m,
  InputNumber: g,
  DynamicInput: f,
  ThemeEditor: h,
  Image: C,
  SortFilter: P,
  IconPicker: T,
  Spacing: D,
  BrandColorPicker: S,
  BrandBoard: A
};
export {
  A as BrandBoard,
  S as BrandColorPicker,
  t as Cascader,
  a as DataTable,
  n as DatePicker,
  f as DynamicInput,
  u as DynamicTags,
  i as Empty,
  T as IconPicker,
  C as Image,
  m as Input,
  g as InputNumber,
  o as LegacyTransfer,
  p as Log,
  d as Pagination,
  r as Popconfirm,
  c as Select,
  P as SortFilter,
  D as Spacing,
  h as ThemeEditor,
  s as TimePicker,
  l as Transfer,
  v as default,
  e as global
};
